
import Vue, { PropType } from 'vue'
import TopHeaderMenu from './top-header-menu/index.vue'
import BottomHeaderMenu from './bottom-header-menu/index.vue'
import BottomHeaderMenuStatic from './bottom-header-menu-static/index.vue'
import MobileHeaderMenu from './mobile-header-menu/index.vue'
import MobileSidebar from './mobile-sidebar/index.vue'
import UiSearch from '~/components/ui/search/index.vue'
import TopHeaderStatic from '~/components/ui/header/top-header-static/index.vue'
import { MAIN_PAGE_CODE } from '~/constants/pages'
import { stopScroll } from '~/utils/stopScroll'
// import UiModal from '~/components/ui/common/ui-modal/ui-modal.vue'

interface LinkItem {
  title: string;
  code: string;
  children: LinkItem[];
  isUrl?: boolean;
}

export default Vue.extend({
  components: {
    UiSearch,
    // UiModal,
    TopHeaderMenu,
    BottomHeaderMenu,
    BottomHeaderMenuStatic,
    TopHeaderStatic,
    MobileHeaderMenu,
    MobileSidebar
  },
  inject: ['layoutProvider'],
  provide: function () {
    return {
      provider: this.provider,
      layoutProvider: this.layoutProvider
    }
  },
  props: {
    userType: {
      type: Object as PropType<{ business: boolean }>,
      required: true
    },
    sections: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      FEEDBACK_MODAL_ID: this.$config?.app?.forms?.ids?.FEEDBACK,

      provider: {
        visibleMobileMenuCode: ''
      },

      isOpenFormModal: false
    }
  },
  computed: {
    //* Текущий идентификатор сайта
    currentSite (): string {
      return (
        this.$authNew?.sites?.find(site => site.id === this.$authNew?.siteId)
          ?.name || 'Иваново'
      )
    },

    currentRouteMap (): LinkItem {
      let currRoute = this.sections?.find(
        (section: { code: string; useIndexHeader?: boolean }) =>
          this.$route.path?.split('/')?.[1] === section?.code &&
          !section?.useIndexHeader
      )

      currRoute ??= this.sections?.find(
        (section: { code: string }) => section?.code === 'index'
      )
      return currRoute
    },

    showSearch: {
      get () {
        return this.$route.query?.search
      },
      set (value: 'visible' | undefined) {
        this.$router.push({ query: { search: value } })
      }
    }
  },
  watch: {
    '$route.query.search' (search?: string) {
      stopScroll(!!search || !!this.provider.visibleMobileMenuCode)
    },
    'provider.visibleMobileMenuCode' (visibleMobileMenuCode: string) {
      stopScroll(!!this.$route?.query?.search || !!visibleMobileMenuCode)
    },
    '$route.query.form' (form?: string) {
      this.isOpenFormModal = form === `${this.FEEDBACK_MODAL_ID}`
    }
  },
  methods: {
    filterHeaderSections () {
      return this.sections?.filter(section => section?.showInHeader)
    },

    parseRoute (route: string) {
      if (route === '/') {
        return MAIN_PAGE_CODE
      }
      const routeArr = route.split('/')
      routeArr[routeArr.indexOf('')] = MAIN_PAGE_CODE
      return routeArr.join('.')
    },

    changeMenuCode (code?: string) {
      this.$set(this.provider, 'visibleMobileMenuCode', code || '')
    },

    invertSearchShow () {
      this.showSearch = this.showSearch ? undefined : 'visible'
    }
  }
})
